import React, { useEffect, useCallback } from "react";
import { debounce } from "instantsearch.js/es/lib/utils";
import { useSelector } from "react-redux";
import { UseSearchBoxProps, useSearchBox } from "react-instantsearch";

const CustomVirtualSearchBox = (props: UseSearchBoxProps) => {
  const { query, refine } = useSearchBox(props);
  const { algoliaQuery } = useSelector((state) => state.algoliaSearch);

  const debouncedSearch = useCallback(
    debounce((newQuery, prevQuery) => {
      if (prevQuery !== newQuery) {
        refine(newQuery);
      }
    }, 300),
    []
  );

  useEffect(() => {
    debouncedSearch(algoliaQuery, query);
  }, [algoliaQuery]);

  return null;
};

export default CustomVirtualSearchBox;
